import React from 'react';
import loadable from '@loadable/component';
import { useSelector } from 'react-redux';
import { OverlayId } from '../../../client/components/Overlays/types';
import StateInterface from '../../../client/redux/types';
import { getOverlayById } from '../../../client/redux/overlays/selectors';
import { CartProps } from './CartContent';

const CartContent = loadable(() => import('./CartContent'));
const ContentOverlay = loadable(() => import('../../../client/components/Overlays/ContentOverlay'));
const RIGHT_POSITION = 15;

interface Props extends CartProps {
    cartCount: number;
}
const CartOverlay: React.SFC<Props> = ({ cartUrl, carts, subtotal, cartCount }) => {
    const isCartOverlayActive = useSelector<StateInterface, boolean>(
        state => getOverlayById(state.overlays, OverlayId.DESKTOP_CART_OVERLAY).isActive
    );
    const showCartOverlay = cartCount > 0 && isCartOverlayActive;

    return showCartOverlay ? (
        <ContentOverlay
            identifier={OverlayId.DESKTOP_CART_OVERLAY}
            rightPosition={RIGHT_POSITION}
            propagateOutsideClicks
        >
            <CartContent carts={carts} subtotal={subtotal} cartUrl={cartUrl} />
        </ContentOverlay>
    ) : (
        <></>
    );
};

export default CartOverlay;
